import { Component } from '@angular/core';
import { ScreenSeatsSelectedListComponent } from 'libs/shared/src/lib/component/seats-selected-list/seats-selected-list.component';

@Component({ standalone: false, selector: 'app-selected-seats', templateUrl: './seats-selected-list.component.html' })
export class CustomScreenSeatsSelectedListComponent extends ScreenSeatsSelectedListComponent {}
